export class BlackListInfo {
  // public 変数 ------------------------------------------------------------------------
  public blackListId:     string 			= null;   // ブラックリストID
  public surnameHan:      string			= null;   // 被保険者名半カナ（性）
  public firstnameHan:    string			= null;   // 被保険者名半カナ（名）
  public dateOfBirthYyyy: string			= null;   // 生年月日（年）
  public dateOfBirthMm:   string			= null;   // 生年月日（月）
  public dateOfBirthDd:   string			= null;   // 生年月日（日）
  public phoneNumber:     string			= null;   // 電話番号
  // ------------------------------------------------------------------------------------
}
